import { WidgetComponent } from '@yodlee/common-components';
import React from 'react';
// import * as YccSRWidgets from '@yodlee/ycc-service-request-widget';
declare global {
    interface Window {
        [key: string]: any,
    }
}
interface IPackageLoader {
    bundleUrl: string,
    packageName: string,
    contextValue: any,
    contextSetter: Function
};

export class PackageLoader extends React.Component<IPackageLoader, any, any> {
    constructor(props: IPackageLoader) {
        super(props);
        this.state = {
            loading: true,
            error: false
        }
    }

    componentDidMount() {
        try {
            let { bundleUrl, packageName, contextSetter, contextValue } = this.props;
            let self = this;
            if (contextValue) { // don't execute if we already have widgets loaded
                this.setState({ loading: false, error: false });
                return;
            }
            const script = document.createElement('script');
            script.id = bundleUrl; script.src = bundleUrl;
            script.onerror = function (e) {
                console.error('script loading failed', self.props, e);
                self.setState({ loading: false, error: true });
            }
            const onLoad = () => {
                window[packageName](function (widgets: any, err: any) {
                    if (err) {
                        console.error('failed from bundler', self.props, err);
                        self.setState({ loading: false, error: true });
                        return;
                    }
                    contextSetter(widgets);
                    self.setState({ loading: false, error: false });
                    // widgets.CreateServiceRequest("#harsh_yay", { authentication: getAuthenticationDetails() })
                });
            }
            script.onload = onLoad;
            if (!document.getElementById(script.src)) {
                document.body.appendChild(script);
            } else { //if script exsist and  window[packageName] exsisit and contextSetter has nothing then load content
                if (window[packageName] && !contextValue) {
                    onLoad();
                } else {
                    console.error('UNSEEN SITUATION IN PACKAGE_LOADER');
                    self.setState({ loading: false, error: true });
                }
            }
        } catch (e) {
            console.error('Failed in package loader component did mount', this.props, e);
            this.setState({ loading: false, error: true });
        }
    }

    render() {
        return (
            <>
                {this.state.loading ? <div style={{ position: 'relative', height: '200px' }}>
                    <WidgetComponent.WidgetWrapper type='load' />
                </div> : null}
                {this.state.error ? <div style={{ position: 'relative', height: '200px' }}>
                    <WidgetComponent.WidgetWrapper type='error' />
                </div> : null}
                {(!this.state.loading && !this.state.error) ? this.props.children : null}
            </>
        )
    }
}
